export default "__VITE_ASSET__0bcbdcd5__"